import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TextComponent } from '@app/components/text/text.component';

@Component({
  selector: 'app-header-badge-text',
  templateUrl: './header-badge-text.component.html',
  styleUrl: './header-badge-text.component.scss',
  imports: [
    TextComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBadgeTextComponent {

  public readonly text = input.required<string>();

}
